import * as t from "io-ts";
import { Venue } from "./venue";

const Text = t.type({
  text: t.string,
  html: t.string,
});

const DateTime = t.type({
  timezone: t.string,
  local: t.string,
  utc: t.string,
});

const OriginalLogo = t.type({
  url: t.string,
  width: t.number,
  height: t.number,
});

const Logo = t.type({
  original: OriginalLogo,
  id: t.string,
  url: t.string,
  aspect_ratio: t.string,
});

export const EventbriteEvent = t.type({
  name: Text,
  url: t.string,
  start: DateTime,
  venue: Venue,
  id: t.string,
  logo: t.union([Logo, t.null]),
  // The following items are returned by Eventbrite but currently not
  // used. Uncomment any properties that are needed.
  // description: Text,
  // end: DateTime,
  // organization_id: t.string,
  // created: t.string,
  // changed: t.string,
  // published: t.string,
  // capacity: t.number,
  // capacity_is_custom: t.boolean,
  // status: t.string,
  // currency: t.string,
  // listed: t.boolean,
  // shareable: t.boolean,
  // invite_only: t.boolean,
  // online_event: t.boolean,
  // show_remaining: t.boolean,
  // tx_time_limit: t.number,
  // hide_start_date: t.boolean,
  // hide_end_date: t.boolean,
  // locale: t.string,
  // is_locked: t.boolean,
  // privacy_setting: t.string,
  // is_series: t.boolean,
  // is_series_parent: t.boolean,
  // inventory_type: t.string,
  // is_reserved_seating: t.boolean,
  // show_pick_a_seat: t.boolean,
  // show_seatmap_thumbnail: t.boolean,
  // show_colors_in_seatmap_thumbnail: t.boolean,
  // source: t.string,
  // is_free: t.boolean,
  // version: t.union([t.string, t.null]),
  // summary: t.string,
  // facebook_event_id: t.union([t.string, t.null]),
  // logo_id: t.string,
  // organizer_id: t.string,
  // category_id: t.string,
  // subcategory_id: t.union([t.string, t.null]),
  // format_id: t.string,
  // resource_uri: t.string,
  // is_externally_ticketed: t.boolean,
});

export type EventbriteEvent = t.TypeOf<typeof EventbriteEvent>;

export const EventbriteResponse = t.type({
  events: t.array(EventbriteEvent),
});

export type EventbriteResponse = t.TypeOf<typeof EventbriteResponse>;
